import Vue from 'vue'
import { Decimal } from 'decimal.js'

export default {
	loggedIn(state) {
		return state.token !== null
	},
	TOKEN(state) {
		return state.token
	},
	SERVER_URL(state) {
		return state.serverURL
	},
	BACKEND_URL(state) {
		return state.backendURL
	},
	USER(state) {
		return state.user
	},
	isAuthenticated(state) {
		return !!state.token
	},
	authStatus(state) {
		return state.status
	},

	getContractConfigs: (state) => (contractId) => {
		const contractConfig = state.contractConfigs[contractId]

		if (!contractConfig) {
			return {
				contractStatus: 'disabled',

				weightInGram: -1,
				weightMultiplication: -1,
				weightCorrection: 1,
				depthTTDecimalPlace: 2,
				tbTtDecimalPlace: 2,
				depthQuantityDecimalPlace: 0,
				hasQuantityDecimal: false,
				contractType: 'igx',
				codeName: '-',
				tradeTicketName: '-',
				name: '-',
				tradeBoxName: '-',
				rrsName: '-',

				realAccountOnly: false,

				ohlcId: -1,
			}
		}

		return contractConfig
	},

	getAccountLevel(state) {
		let temp = state.account
		// const template = { IB: 'ib', PB: 'fm', LP: 'lp', PC: 'client' }
		if (temp) {
			return 'client' //template[temp.hin.substr(0, 2)]
		} else {
			return 'client'
		}
	},

	getBrokerName(state) {
		const brokerName = state.authInfo

		if (!brokerName) {
			return '-'
		}

		return brokerName.app_name.toLowerCase()
	},

	depthById: (state) => (depthId) => {
		let temp
		if (depthId == '6') {
			temp = state.kinesisDepth
		} else {
			temp = state.depths
		}

		if (temp) {
			if (depthId == '6') {
				temp.buy = temp.buy.map(obj => ({ ...obj, quantity: obj.amount }))
				temp.sell = temp.sell.map(obj => ({ ...obj, quantity: obj.amount }))
				return temp
			} else {
				return state.depths[depthId]
			}
		} else {
			return null
		}
	},

	customDepthByCustomId: (state) => (customId) => {
		// console.log('WEGWEGWEG', customId, JSON.parse(JSON.stringify(state.customDepths)))
		if (!customId) {
			return null
		}

		const customDepth = state.customDepths[customId]
		if (customDepth) {
			return customDepth
		}

		return null
	},

	contractConfigByCustomId: (state) => (customId) => {
		const contractConfig = state.contractsConfig[customId]
		if (contractConfig) {
			return contractConfig
		}

		return null
	},

	contractConfigByContractId: (state) => (contractId) => {
		const contractConfig = Object.keys(state.contractsConfig).find(prop1 => state.contractsConfig[prop1].contractId == contractId && state.contractsConfig[prop1].original)
		if (contractConfig) {
			return state.contractsConfig[contractConfig]
		}

		return null
	},

	goldById: (state) => (goldId) => {
		let gold = state.gold
		if (gold) {
			let oneGold = gold[goldId]
			if (oneGold) {
				//set sell price
				if (oneGold.sell < 0 && oneGold.buy >= 0) {
					if (state.currency == 'idr' && (oneGold.id == 1 || oneGold.id == 3)) {
						oneGold.sell = Number(oneGold.buy.toFixed(0))
					} else {
						oneGold.sell = oneGold.buy
					}
				} else {
					if (state.currency == 'idr' && (oneGold.id == 1 || oneGold.id == 3)) {
						oneGold.sell = Number(oneGold.sell.toFixed(0))
					}
				}

				//set buy price
				if (oneGold.buy < 0 && oneGold.sell >= 0) {
					if (state.currency == 'idr' && (oneGold.id == 1 || oneGold.id == 3)) {
						oneGold.buy = Number(oneGold.buy.toFixed(0))
					} else {
						oneGold.buy = oneGold.sell
					}
				} else {
					if (state.currency == 'idr' && (oneGold.id == 1 || oneGold.id == 3)) {
						oneGold.buy = Number(oneGold.buy.toFixed(0))
					}
				}

				return oneGold
			} else {
				return null
			}

		} else {
			return null
		}
	},

	getGoldByContractId: (state) => (contractId) => {
		let golds = state.golds
		if (golds) {
			return golds[contractId]
		} else {
			return null
		}
	},

	getOhlcByContractId: (state) => (contractId) => {
		const ohlc = state.ohlc
		if (ohlc) {
			return ohlc[contractId]
		} else {
			return {
				low: 0,
				high: 0,
				change: 0,
				caretDirection: 'down',
				percentage: 0.0,
			}
		}
	},

	PRODUCTS(state) {
		let products = state.products
		let arr = []
		if (products) {
			products.forEach((product) => {
				if (product) {
					if (product.id == '46') { //100 gram
						// product.attributes.aliasName = '100 gram Swiss Bar'
					} else if (product.id == '1') { // 1 kg
						// product.attributes.aliasName = '1 kg Bar'
					} else if (product.id == '47') { // 10 kg
						// product.attributes.aliasName = 'Wholesale AAU 10 kg'
					} else if (product.id == '39') { // 10 oz
						// product.attributes.aliasName = '10 oz Swiss Bar'
					}
					arr.push(product)
				}
			})
			return arr
		} else {
			return null
		}
	},
	productById: (state, getters) => (productId) => {
		let products = getters.PRODUCTS
		if (products) {
			let product = products.find(obj => obj.id == productId)
			if (product) {
				return product
			}
			return null
		}
		return null
	},
	getStreamingRate(state) {
		// let streamingRate = structuredClone(state.streamingRate)
		// if (!streamingRate || (streamingRate || {}).stream_buy == 0) {
		// 	return {
		// 		stream_buy: {
		// 			cur_rate: -1
		// 		},
		// 		stream_sell: {
		// 			cur_rate: -1
		// 		}
		// 	}
		// }

		// return {
		// 	stream_buy: {
		// 		cur_rate: streamingRate.streamBuy
		// 	},
		// 	stream_sell: {
		// 		cur_rate: streamingRate.streamSell
		// 	}
		// }

		const streamingRate = structuredClone(state.streamingRate)
		if (!streamingRate || (streamingRate || {}).stream_buy == 0) {
			return {
				streamBuy: -1,
				streamSell: -1
			}
		}

		return {
			streamBuy: streamingRate.stream_buy.cur_rate,
			streamSell: streamingRate.stream_sell.cur_rate
		}
	},
	getHin(state) {
		let account = state.account
		if (account) {
			return account.attributes.hin
		} else {
			return '-'
		}
	},
	getFirstName(state) {
		let account = state.account
		if (account) {
			return account.attributes.firstName
		} else {
			return '-'
		}
	},
	getHinKinesis(state) {
		let account = state.accountKinesis
		if (account) {
			return account.hin
		} else {
			return '-'
		}
	},

	// getBalances(state) {
	// 	let balances = state.balances
	// 	if (balances) {
	// 		return balances
	// 	}else {
	// 		return null
	// 	}
	// }

	// getTotalGold(state) {
	// 	const holdings = state.holdings
	// 	let totalGold = [
	// 		{
	// 			contractId: 626,
	// 			status: 'active',
	// 			product: '100 gram',
	// 			quantity: 0,
	// 		},
	// 		{
	// 			contractId: 264,
	// 			status: 'active',
	// 			product: '1 kg',
	// 			quantity: 0,
	// 		},
	// 		{
	// 			contractId: 633,
	// 			status: 'active',
	// 			product: '10 kg',
	// 			quantity: 0,
	// 		},
	// 		{
	// 			contractId: 271,
	// 			status: 'disabled',
	// 			product: '10 Oz',
	// 			quantity: 0,
	// 		}
	// 	]

	// 	if (holdings) {
	// 		holdings.forEach((holding) => {
	// 			let index = totalGold.findIndex(obj => obj.contractId == holding.attributes.contractId)
	// 			if (totalGold[index]) {
	// 				totalGold[index].quantity = holding.attributes.value
	// 			}
	// 		})

	// 		return totalGold
	// 	} else {
	// 		return totalGold
	// 	}
	// },

	getTotalGold(state, getters) {
		// const contractOrder = [7, 5, 1, 3] //contract id
		const holdings = state.holdings

		let totalGold = []

		if (holdings) {
			holdings.forEach((holding, index) => {
				const contractConfig = getters.getContractConfigs(holding.contract_id)

				const tempTotalGold = {
					contractId: holding.contract_id,
					product: contractConfig.name,
					quantity: Number(Decimal.div(holding.attributes.value, contractConfig.weightCorrection)),
					weight: Number(contractConfig.weightInGram),
					weightCorrection: Number(contractConfig.weightCorrection),
					totalGram: Number(Decimal.mul(contractConfig.weightInGram, Decimal.div(holding.attributes.value, contractConfig.weightCorrection))),
				}

				Vue.set(totalGold, index, tempTotalGold)
			})

			return totalGold
		} else {
			return null
		}
	},

	getContractStatus(state) {
		const contracts = state.contracts
		let contractStatus = {
			goldMicro: {
				contractId: 5,
				status: 'disabled',
			},
			gold1Gram: {
				contractId: 6,
				status: 'disabled',
			},
			gold100Gram: {
				contractId: 1,
				status: 'disabled',
			},
			gold10Oz: {
				contractId: 2,
				status: 'disabled',
			},
			gold1Kg: {
				contractId: 3,
				status: 'disabled',
			},
			gold10Kg: {
				contractId: 4,
				status: 'disabled',
			},
		}

		if (contracts) {
			contracts.forEach((contract) => {
				let index = contractStatus.findIndex(obj => obj.contractId == contract.id)
				contractStatus[index].quantity = contract.attributes.value
			})

			return contractStatus
		} else {
			return null
		}
	},

	getContractById: (state) => (contractId) => {
		const contract = state.contracts.find(obj => obj.id == contractId)
		if (contract) {
			return contract
		} else {
			return null
		}
	},

	// HOLDING vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
	getHolding(state) { // holdings after the QUANTITY has been corrected
		const holdings = state.holdings

		let newHoldings = []
		holdings.forEach((holding) => {
			const contractConfig = state.contractConfigs[holding.attributes.contractId]
			newHoldings.push({
				...holding,
				contractId: holding.attributes.contractId,
				quantity: Decimal.div(holding.attributes.value, contractConfig.weightCorrection).toNumber(),
			})
		})

		return newHoldings
	},
	getHoldingByContractId: (state, getters) => (contractId) => {
		const holdings = getters.getHolding
		if (holdings) {
			return holdings.find(obj => obj.contractId == contractId)
		} else {
			return null
		}
	},

	getMetalValueAtDateUsdByContractId: (state, getters) => (contractId, limitPrice = -1) => {
		if (!state.golds) {
			return new Decimal(-1)
		}

		const tempGold = state.golds[contractId]
		if (!tempGold) {
			return new Decimal(-1)
		}

		let goldPriceNow = new Decimal(tempGold.contractPriceSell)

		if (new Decimal(limitPrice).toNumber() != -1) {
			goldPriceNow = Decimal.mul(limitPrice, state.contractConfigs[contractId].weightMultiplication)
		}

		// goldPriceNow should be contract price. Meaning, the price per contract's weight

		const holding = getters.getHoldingByContractId(contractId)
		let temp = new Decimal(goldPriceNow).times(holding.quantity)

		if (contractId == 0 || temp.equals(0)) {
			return new Decimal(0)
		}

		let fee = Decimal.mul(temp, state.fee).toDecimalPlaces(3)
		if (fee.lessThan(state.feeMin)) {
			fee = new Decimal(state.feeMin)
		}

		let tax = Decimal.mul(fee, state.tax).toDecimalPlaces(3)
		if (tax.lessThan(state.taxMin)) {
			tax = new Decimal(state.taxMin)
		}

		return Decimal.sub(temp, Decimal.add(fee, tax)).toDecimalPlaces(2)
	},

	getMetalValueAtDateIdrByContractId: (state, getters) => (contractId, limitPrice = -1) => {
		if (!state.golds) {
			return new Decimal(-1)
		}

		const tempGold = state.golds[contractId]
		if (!tempGold) {
			return new Decimal(-1)
		}

		let goldPriceNow = new Decimal(tempGold.contractPriceSell)
		if (limitPrice != -1) {
			goldPriceNow = Decimal.mul(limitPrice, state.contractConfigs[contractId].weightMultiplication)
		}

		const streamingRate = getters.getStreamingRate
		goldPriceNow = Decimal.mul(goldPriceNow, streamingRate.streamSell).toDecimalPlaces(2)

		// goldPriceNow should be contract price. Meaning, the price per contract's weight

		const holding = getters.getHoldingByContractId(contractId)
		let temp = new Decimal(goldPriceNow).times(holding.quantity)

		if (contractId == 0 || temp.equals(0)) {
			return new Decimal(0)
		}

		let feeTax = temp.times(state.feeTaxMultiplier).toDecimalPlaces(2)
		if (temp.lessThanOrEqualTo(state.totalIdrMin)) {
			feeTax = Decimal.mul(state.feeTaxMin, streamingRate.streamSell).toDecimalPlaces(2)
		}

		return temp.minus(feeTax).toDecimalPlaces(2)
	},

	getEstimatePNLUsdByContractId: (state, getters) => (contractId, limitPrice = -1) => {
		const holding = getters.getHoldingByContractId(contractId)

		let tempAMC
		if (getters.getAccountLevel == 'fm' || getters.getAccountLevel == 'ib') {
			tempAMC = holding.averageTotalCostIncFeeAndTaxUsd
		} else {
			tempAMC = holding.avg_total_cost
		}

		const metalValueAtDate = getters.getMetalValueAtDateUsdByContractId(contractId, limitPrice)
		if (metalValueAtDate.lessThan(0) || isNaN(holding.quantity)) {
			return '-'
		}

		if (holding.quantity == 0) {
			return new Decimal(0)
		}

		return Decimal.sub(metalValueAtDate, (tempAMC || 0)).toDecimalPlaces(2)
	},
	getEstimatePNLIdrByContractId: (state, getters) => (contractId, limitPrice = -1) => {
		const holding = getters.getHoldingByContractId(contractId)

		let tempAMC
		if (getters.getAccountLevel == 'fm' || getters.getAccountLevel == 'ib') {
			tempAMC = holding.averageTotalCostIncFeeAndTaxIdr
		} else {
			tempAMC = holding.avg_total_cost_idr
		}

		const metalValueAtDate = getters.getMetalValueAtDateIdrByContractId(contractId, limitPrice)
		if (metalValueAtDate.lessThan(0) || isNaN(holding.quantity)) {
			return '-'
		}

		if (holding.quantity == 0) {
			return new Decimal(0)
		}

		return Decimal.sub(metalValueAtDate, (tempAMC || 0)).toDecimalPlaces(2)
	},

	// HOLDING ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

	getGoldBalance(state) { // goldBalance after the QUANTITY and WEIGHT has been corrected
		const goldBalance = state.goldBalance
		const reservedGoldOrder = state.reservedDeliveryGoldOrder

		let newGoldBalance = []
		reservedGoldOrder.forEach((order) => {
			const contractConfig = state.contractConfigs[order.contractId]
			const gold = goldBalance.find((obj) => obj.contract_id == order.contractId)

			newGoldBalance.push({
				contractId: gold.contract_id,
				product: gold.product,
				availableQuantity: Decimal.div(gold.availabe_qty, contractConfig.weightCorrection).toNumber(),
				quantity: Decimal.div(gold.quantity, contractConfig.weightCorrection).toNumber(),
				onProcess: Decimal.div(gold.on_process, contractConfig.weightCorrection).toNumber(),
				reservedDeliveryQuantity: Decimal.div(gold.reserved_delivery_qty, contractConfig.weightCorrection).toNumber(),
				reservedQuantity: Decimal.div(gold.reserved_qty, contractConfig.weightCorrection).toNumber(),
			})
		})

		return newGoldBalance
	},
	getGoldBalanceByContractId: (state, getters) => (contractId) => {
		const goldBalance = getters.getGoldBalance
		if (goldBalance) {
			return goldBalance.find(obj => obj.contractId == contractId)
		} else {
			return null
		}
	},



	marketInquiryIsLoading(state) {
		return (state.marketInquiryStatus == 'loading') ? true : false
	},
}